module.exports = __webpack_public_path__ + "static/media/DSC04210.4a9382ec.JPG";